import { useEffect, useState, useCallback } from "react";
import { Plus, Trash2 } from "lucide-react";
import { api } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { toast } from "sonner";

export default function AdminTaxonomy() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ kind: "category", slug: "", en: "", es: "", nl: "" });

  const load = useCallback(() => {
    api.get("/api/admin/taxonomy").then(({ data }) => setItems(data)).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  async function create() {
    if (!form.slug || !form.en) { toast.error("Slug and EN name required"); return; }
    try {
      await api.post("/api/admin/taxonomy", {
        kind: form.kind, slug: form.slug,
        translations: { en: { name: form.en }, es: { name: form.es }, nl: { name: form.nl } },
      });
      toast.success("Created"); setForm({ kind: form.kind, slug: "", en: "", es: "", nl: "" }); load();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  }

  async function del(id) { await api.delete(`/api/admin/taxonomy/${id}`); load(); }

  return (
    <div className="mx-auto max-w-4xl">
      <h1 className="font-heading text-2xl font-extrabold text-slate-900">Taxonomy</h1>
      <p className="mt-1 text-sm text-slate-500">Categories and tags with multilingual names.</p>

      <div className="mt-6 grid gap-3 rounded-2xl border border-slate-200 bg-white p-6 sm:grid-cols-6">
        <div><Label>Kind</Label>
          <select value={form.kind} onChange={(e) => setForm({ ...form, kind: e.target.value })} data-testid="tax-kind" className="mt-1.5 w-full rounded-md border border-slate-200 px-2 py-2 text-sm">
            <option value="category">category</option><option value="tag">tag</option>
          </select>
        </div>
        <div><Label>Slug</Label><Input value={form.slug} onChange={(e) => setForm({ ...form, slug: e.target.value })} className="mt-1.5" data-testid="tax-slug" /></div>
        <div><Label>EN</Label><Input value={form.en} onChange={(e) => setForm({ ...form, en: e.target.value })} className="mt-1.5" /></div>
        <div><Label>ES</Label><Input value={form.es} onChange={(e) => setForm({ ...form, es: e.target.value })} className="mt-1.5" /></div>
        <div><Label>NL</Label><Input value={form.nl} onChange={(e) => setForm({ ...form, nl: e.target.value })} className="mt-1.5" /></div>
        <div className="flex items-end"><Button onClick={create} data-testid="tax-create" className="w-full rounded-full bg-emerald-600 hover:bg-emerald-700"><Plus className="h-4 w-4" /></Button></div>
      </div>

      <div className="mt-6 divide-y divide-slate-100 rounded-2xl border border-slate-200 bg-white">
        {items.map((it) => (
          <div key={it.id} className="flex items-center gap-4 px-4 py-3 text-sm">
            <span className="rounded bg-slate-100 px-2 py-0.5 text-xs font-semibold text-slate-600">{it.kind}</span>
            <span className="font-medium text-slate-800">{it.slug}</span>
            <span className="text-slate-400">{it.translations?.en?.name} · {it.translations?.es?.name} · {it.translations?.nl?.name}</span>
            <button onClick={() => del(it.id)} className="ml-auto text-red-500 hover:text-red-700"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
        {items.length === 0 && <div className="px-4 py-8 text-center text-slate-400">No taxonomy yet.</div>}
      </div>
    </div>
  );
}
